import React from "react";
import { startInternalBrowserAutofillGuard } from "../app/utils/internalBrowserAutofill";

/** Unterdrückt Browser-Adress-/Passwortspeichern in internen Masken, ohne jedes Feld einzeln zu markieren. */
export function InternalBrowserAutofillGuard() {
  React.useEffect(() => startInternalBrowserAutofillGuard(), []);
  return null;
}
